import React from 'react';
import { DotPage } from '@ssv-website/web-ui';
import { Paging as PagingComponent, IPaging } from '@/components/Paging';
import arrow_icon from '../images/arrow-icon.svg';
import arrow_active_icon from '../images/arrow-active-icon.svg';

const CasePaging = (props: IPaging & { className?: string }) => {
  const { className = '', ...rest } = props;
  if ({ className, ...rest }.total <= 1) return null;
  return (
    <div className={className}>
      <div className="flex justify-center mobile:hidden">
        <PagingComponent
          activeIcon={arrow_active_icon}
          icon={arrow_icon}
          textColor="#353F49"
          {...rest}
          total={rest.total || 1}
        />
      </div>
      <div className="hidden mobile:flex justify-center gap-[2px] mt-4">
        {Array(rest.total || 0)
          .fill(0)
          .map((_, index) =>
            index === rest.page - 1 ? (
              <div key={index} className="w-2 h-1 bg-[#323C46] rounded-sm" />
            ) : (
              <div
                key={index}
                className="w-1 h-1 bg-[#323C46]/20 rounded-full"
              />
            )
          )}
      </div>
    </div>
  );
};

export default CasePaging;
